<pos-stepper #cdkStepper linear="true">
  <cdk-step label="Devolver contrato">
    <app-return-contract-step [loan]="loan" (returnContractCompleted)="handleReturnComplete($event)"></app-return-contract-step>
  </cdk-step>
</pos-stepper>
